import api from "@/services/api";

const getGoogleAuthUrl = async () => {
  const resp = await api.get("/auth/social/google");
  return resp.data.data.url as string;
};

const authenticateWithGoogle = async (code: string) => {
  const resp = await api.post("/auth/social/google", { data: { code } });
  api.setAccessToken(resp.data.data.token, true);
};

export default {
  getGoogleAuthUrl,
  authenticateWithGoogle,
};
